var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": !!_vm.type,
      "max-width": "600",
      "persistent": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(_vm._s(_vm.computedTitleDialog))]), _c('v-card-text', {
    staticClass: "border-top py-4",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [!_vm.checkMsg ? [_vm.computedLabel ? _c('v-text-field', {
    attrs: {
      "label": _vm.computedLabel,
      "placeholder": _vm.computedPlaceholder,
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "rounded": ""
    },
    model: {
      value: _vm.text,
      callback: function callback($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }) : _c('p', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s(_vm.computedMessageDialog))])] : [_vm._l(_vm.messages, function (item, i) {
    return _c('p', {
      key: i,
      staticClass: "accent--text"
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), !_vm.messages.length ? _c('p', {
    staticClass: "accent--text"
  }, [_vm._v("Сообщений нет")]) : _vm._e()]], 2), _c('v-card-actions', {
    staticClass: "px-6 pt-0"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Отмена")]), !_vm.checkMsg ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "lightGrey",
      "disabled": _vm.$v.$invalid && _vm.disabledBtn,
      "text": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s('Принять') + " ")]) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }